import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faGraduationCap,
  faSchool,
  faChevronRight,
  faInbox,
} from "@fortawesome/free-solid-svg-icons";
import "./batch-picker.css";

type Props = {
  batches: Array<Object>;
  onSelectBatch: (arg0: any) => any;
};

type States = {
  query: string;
};

export class BatchPicker extends React.Component<Props, States> {
  state: States = { query: "" };

  handleClick = (batch: any) => {
    this.props.onSelectBatch && this.props.onSelectBatch(batch);
  };

  handleQuery = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ query: e.target.value });
  };

  render() {
    const all = (this.props.batches || []) as any[];
    const q = this.state.query.trim().toLowerCase();
    const filtered = q
      ? all.filter((b) =>
          [b?.name, b?.courseName, b?.schoolName]
            .filter(Boolean)
            .some((v: string) => String(v).toLowerCase().includes(q)),
        )
      : all;

    return (
      <div className="bp-root">
        <div className="bp-search">
          <FontAwesomeIcon icon={faSearch} className="bp-search-icon" />
          <input
            type="text"
            className="bp-search-input"
            placeholder="Search by batch, course, or school"
            value={this.state.query}
            onChange={this.handleQuery}
            autoFocus
          />
          {all.length > 0 && (
            <span className="bp-count">
              {filtered.length} / {all.length}
            </span>
          )}
        </div>

        {filtered.length === 0 ? (
          <div className="bp-empty">
            <FontAwesomeIcon icon={faInbox} className="bp-empty-icon" />
            <p className="bp-empty-title">
              {all.length === 0 ? "No batches available" : "No matches found"}
            </p>
            {all.length > 0 && (
              <p className="bp-empty-sub">Try a different search term.</p>
            )}
          </div>
        ) : (
          <ul className="bp-list">
            {filtered.map((batch: any, i: number) => (
              <li key={batch?.id ?? i} className="bp-item-row">
                <button
                  type="button"
                  className="bp-item"
                  onClick={() => this.handleClick(batch)}
                >
                <div className="bp-item-accent" aria-hidden="true" />
                <div className="bp-item-body">
                  <div className="bp-item-title" title={batch?.name}>
                    {batch?.name}
                  </div>
                  {batch?.courseName && (
                    <div className="bp-item-meta">
                      <FontAwesomeIcon
                        icon={faGraduationCap}
                        className="bp-item-meta-icon"
                      />
                      <span>{batch.courseName}</span>
                    </div>
                  )}
                  {batch?.schoolName && (
                    <div className="bp-item-meta bp-item-meta-muted">
                      <FontAwesomeIcon
                        icon={faSchool}
                        className="bp-item-meta-icon"
                      />
                      <span>{batch.schoolName}</span>
                    </div>
                  )}
                </div>
                  <FontAwesomeIcon icon={faChevronRight} className="bp-item-chevron" />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}
